import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { interval, Subscription } from 'rxjs';
import { environment } from '../../environments/environment';

// see: https://angular.io/guide/service-worker-communications
@Injectable({
  providedIn: 'root'
})
export class CheckForUpdateService {

  private checkForUpdateSubscription: Subscription;

  constructor(private swUpdate: SwUpdate) {
  }

  startCheckingForUpdates(): void {
    if (!environment.enableServiceWorker) {
      // ignored in environments where service workers (PWA) are not enabled
      return;
    }

    if (!this.checkForUpdateSubscription) {
      const every30Minutes$ = interval(30 * 60 * 1000);
      this.checkForUpdateSubscription = every30Minutes$.subscribe(() => this.swUpdate.checkForUpdate());
    }
  }
}
